import React from "react";

import PaymentOutcome from "../../components/payment-outcome/payment-outcome";

const PaymentSuccess = () => (
  <div className="signup-container">
    <div className="signup-card">
      <PaymentOutcome defaultStatus={"Complete"} />
    </div>
  </div>
);

export default PaymentSuccess;
